import { DialogContent, DialogOverlay } from '@reach/dialog';
import styled from 'styled-components';

import CloseButton from 'components/close-button';
import { primitive } from 'styles/constants/primitives';
import filterProps from 'utils/filter-props';

import { closeDown, openUp } from './animations';
import { IDrawerProps } from './interfaces';

export * from './styled.default';

export const DrawerContainer = styled(filterProps(DialogOverlay, 'disableScroll'))<IDrawerProps>`
  height: 100vh;
  width: 100vw;
`;

export const Overlay = styled.div`
  height: 100vh;
  width: 100vw;
  background-color: ${primitive.$black};
  opacity: 0.5;
  z-index: 800;
  position: absolute;
  top: 0;
`;

export const DrawerContent = styled(DialogContent)`
  display: flex;
  position: absolute;
  flex-direction: column;
  bottom: 0;
  min-height: 40vh;
  width: 100%;
  height: ${({ fullScreen }: IDrawerProps) => (fullScreen ? '95vh' : 'auto')};
  background: ${primitive.$white};
  color: black;
  z-index: 900;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 1rem 1rem 0px 0px;
  ${Styles.mobile`
    animation-name: ${(p: IDrawerProps) => (p.isVisible ? openUp : closeDown)};
    animation-duration: 0.5s;
  `}
`;

export const MobileOptimizedDrawerContent = styled(filterProps(DrawerContent, 'disableScroll'))`
  position: fixed;
  // Pixel family phones in Landscape Mode still needed
  @media only screen and (min-height: 410px) and (max-height: 420px) and (min-width: 800px) {
    height: 80%;
    overflow-y: ${(p: IDrawerProps) => (p.disableScroll ? 'hidden' : 'auto')};
  }
`;

export const StyledCloseButton = styled(CloseButton)`
  align-self: flex-start;
  background-color: transparent;
  position: absolute;
  left: 24px;
  top: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: ${Styles.zIndex.overlay};
`;
